/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

function plural(n: number): number {
  return 5;
}

export default [
  'my',
  [
    ['နံနက်', 'ညနေ'],
    ,
  ],
  ,
  [
    ['တ', 'တ', 'အ', 'ဗ', 'က', 'သ', 'စ'],
    [
      'တနင်္ဂနွေ', 'တနင်္လာ', 'အင်္ဂါ',
      'ဗုဒ္ဓဟူး', 'ကြာသပတေး', 'သောကြာ', 'စနေ'
    ],
    ,
  ],
  ,
  [
    ['ဇ', 'ဖ', 'မ', 'ဧ', 'မ', 'ဇ', 'ဇ', 'ဩ', 'စ', 'အ', 'န', 'ဒ'],
    [
      'ဇန်', 'ဖေ', 'မတ်', 'ဧ', 'မေ', 'ဇွန်', 'ဇူ', 'ဩ',
      'စက်', 'အောက်', 'နို', 'ဒီ'
    ],
    [
      'ဇန်နဝါရီ', 'ဖေဖော်ဝါရီ', 'မတ်', 'ဧပြီ',
      'မေ', 'ဇွန်', 'ဇူလိုင်', 'ဩဂုတ်',
      'စက်တင်ဘာ', 'အောက်တိုဘာ', 'နိုဝင်ဘာ',
      'ဒီဇင်ဘာ'
    ]
  ],
  ,
  [
    ['ဘီစီ', 'အေဒီ'], ,
    ['ခရစ်တော် မပေါ်မီနှစ်', 'ခရစ်နှစ်']
  ],
  0, [6, 0], ['dd-MM-yy', 'y၊ MMM d', 'y၊ d MMMM', 'y၊ MMMM d၊ EEEE'],
  ['B H:mm', 'B HH:mm:ss', 'z HH:mm:ss', 'zzzz HH:mm:ss'],
  [
    '{1} {0}',
    ,
    ,
  ],
  [
    '.', ',', ';', '%', '+', '-', 'E', '×', '‰', '∞',
    'ဂဏန်းမဟုတ်သော', ':'
  ],
  ['#,##0.###', '#,##0%', '#,##0.00 ¤', '#E0'], 'K', 'မြန်မာ ကျပ်', plural
];
